function addHeaderSecureMessage () {

	const wrapper = $('#lpHeader-hdrWrapper');
	wrapper.append('<div id="secureMessage">Your information is safe and secure when ordering from us.</div>');

}

export default addHeaderSecureMessage;
